// Validações e formatações para cartões de crédito
// Versão simplificada - sem dependência do Pagarme.js

export interface CardData {
  number: string;
  holder_name: string;
  exp_month: string;
  exp_year: string;
  cvv: string;
}

/**
 * Valida número de cartão usando algoritmo de Luhn
 */
export function validateCardNumber(number: string): boolean {
  const cleaned = number.replace(/\D/g, '');
  
  if (cleaned.length < 13 || cleaned.length > 19) {
    return false;
  }

  let sum = 0;
  let isEven = false;

  for (let i = cleaned.length - 1; i >= 0; i--) {
    let digit = parseInt(cleaned[i]);

    if (isEven) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }

    sum += digit;
    isEven = !isEven;
  }

  return sum % 10 === 0;
}

/**
 * Detecta bandeira do cartão baseado no número
 */
export function getCardBrand(number: string): string {
  const cleaned = number.replace(/\D/g, '');

  if (/^4/.test(cleaned)) return 'Visa';
  if (/^5[1-5]/.test(cleaned)) return 'Mastercard';
  if (/^3[47]/.test(cleaned)) return 'Amex';
  if (/^6(?:011|5)/.test(cleaned)) return 'Discover';
  if (/^35/.test(cleaned)) return 'JCB';
  if (/^(?:5[06789]|6)/.test(cleaned)) return 'Maestro';
  if (/^62/.test(cleaned)) return 'UnionPay';
  if (/^36|38|30[0-5]/.test(cleaned)) return 'Diners';
  if (/^(?:2131|1800|7)/.test(cleaned)) return 'Elo';

  return 'Desconhecida';
}

/**
 * Formata número de cartão com espaços (0000 0000 0000 0000)
 */
export function formatCardNumber(value: string): string {
  const cleaned = value.replace(/\D/g, '');
  const groups = cleaned.match(/.{1,4}/g);
  return groups ? groups.join(' ') : cleaned;
}

/**
 * Formata data de expiração (MM/AA)
 */
export function formatExpirationDate(value: string): string {
  const cleaned = value.replace(/\D/g, '');
  if (cleaned.length >= 2) {
    return cleaned.slice(0, 2) + '/' + cleaned.slice(2, 4);
  }
  return cleaned;
}
